import { clone } from 'ramda';
import store from '../reducers/storeRegistration';
import { actionRegistrar } from '../actions/entityActionRegistrar';
import { evaluateSource } from '../../behaviors/src/lib/evaluateSource';
import { removeCachedFormContent, setCachedFormContent } from './lib/formContentCache';

/**
 * Write-through shared form-content cache, plus live open-editor update where
 * the platform supports root content replacement (web: form / formModal).
 * Null/undefined only evicts the shared cache (does not clear live content).
 * Does not replace persistence (patchContent / save).
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions) => {
  var _state$form, _state$formModal;
  if (!(source !== null && source !== void 0 && source.uuid)) {
    return undefined;
  }
  const sourceEvaluator = newSource => evaluateSource(newSource, content, parentContentPath, transientContext, nativeFunctions);
  const uuid = await evaluateSource(source.uuid, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator);
  if (!uuid) {
    return undefined;
  }

  // Eviction only — do not null out an open editor's content.
  if (value === null || value === undefined) {
    removeCachedFormContent(uuid);
    return value;
  }
  const state = store.getState();
  // Persisted write-through must not dirty the editor or leave originalActive
  // pointing at pre-patch content (Undo / unsaved UI).
  const quietly = {
    syncOriginal: true
  };
  const clonedContent = clone(value);
  if (((_state$form = state.form) === null || _state$form === void 0 || (_state$form = _state$form.active) === null || _state$form === void 0 ? void 0 : _state$form.id) === uuid) {
    const formActions = actionRegistrar('form');
    await store.dispatch(formActions.changeQuietly(uuid, 'content', clonedContent, quietly));
  } else if (((_state$formModal = state.formModal) === null || _state$formModal === void 0 || (_state$formModal = _state$formModal.active) === null || _state$formModal === void 0 ? void 0 : _state$formModal.id) === uuid) {
    const modalActions = actionRegistrar('formModal');
    await store.dispatch(modalActions.changeQuietly(uuid, 'content', clonedContent, quietly));
  }
  setCachedFormContent(uuid, clonedContent);
  return clonedContent;
};
export default {
  evaluate
};